import {
  BackEase,
  BezierCurveEase,
  BounceEase,
  CircleEase,
  CubicEase,
  EasingFunction,
  ElasticEase,
  ExponentialEase,
  PowerEase,
  QuadraticEase,
  QuarticEase,
  QuinticEase,
  SineEase,
} from '@babylonjs/core';

export enum EasingFunctionType {
  CircleEase,
  BackEase,
  BounceEase,
  CubicEase,
  ElasticEase,
  ExponentialEase,
  PowerEase,
  QuadraticEase,
  QuarticEase,
  QuinticEase,
  SineEase,
  BezierCurveEase,
}

export enum EasingModeType {
  Out,
  In,
  InOut,
}

export type CameraAnimationOption = {
  seconds: number;
  easingFunction: EasingFunctionType;
  easingMode: EasingModeType;
};
export const defaultCameraAnimationOption: CameraAnimationOption = {
  seconds: 0.6,
  easingFunction: EasingFunctionType.CircleEase,
  easingMode: EasingModeType.Out,
};
export const createEasingFunction = (functionType: EasingFunctionType, mode: EasingModeType): EasingFunction => {
  let easingFunction = new CircleEase();
  easingFunction.setEasingMode(EasingFunction.EASINGMODE_EASEOUT);
  switch (functionType) {
    case EasingFunctionType.CircleEase:
      easingFunction = new CircleEase();
      break;
    case EasingFunctionType.BackEase:
      easingFunction = new BackEase();
      break;
    case EasingFunctionType.BounceEase:
      easingFunction = new BounceEase();
      break;
    case EasingFunctionType.CubicEase:
      easingFunction = new CubicEase();
      break;
    case EasingFunctionType.ElasticEase:
      easingFunction = new ElasticEase();
      break;
    case EasingFunctionType.ExponentialEase:
      easingFunction = new ExponentialEase();
      break;
    case EasingFunctionType.PowerEase:
      easingFunction = new PowerEase();
      break;
    case EasingFunctionType.QuadraticEase:
      easingFunction = new QuadraticEase();
      break;
    case EasingFunctionType.QuarticEase:
      easingFunction = new QuarticEase();
      break;
    case EasingFunctionType.QuinticEase:
      easingFunction = new QuinticEase();
      break;
    case EasingFunctionType.SineEase:
      easingFunction = new SineEase();
      break;
    case EasingFunctionType.BezierCurveEase:
      easingFunction = new BezierCurveEase();
      break;
  }
  switch (mode) {
    case EasingModeType.Out:
      easingFunction.setEasingMode(EasingFunction.EASINGMODE_EASEOUT);
      break;
    case EasingModeType.In:
      easingFunction.setEasingMode(EasingFunction.EASINGMODE_EASEIN);
      break;
    case EasingModeType.InOut:
      easingFunction.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);
      break;
  }
  return easingFunction;
};

type EasingFunctionTypeMap = { [key: string]: EasingFunctionType };

export const getEasingFunctionTypeMap = (): EasingFunctionTypeMap => {
  let resultMap: EasingFunctionTypeMap = {};
  let names = Object.keys(EasingFunctionType)
    .map((key: any) => EasingFunctionType[key])
    .filter((value) => typeof value === 'string') as string[];
  for (let name of names) {
    resultMap[name] = EasingFunctionType[name as keyof typeof EasingFunctionType];
  }
  return resultMap;
};

type EasingModeTypeMap = { [key: string]: EasingModeType };

export const getEasingModeMap = (): EasingModeTypeMap => {
  let resultMap: EasingModeTypeMap = {};
  let names = Object.keys(EasingModeType)
    .map((key: any) => EasingModeType[key])
    .filter((value) => typeof value === 'string') as string[];
  for (let name of names) {
    resultMap[name] = EasingModeType[name as keyof typeof EasingModeType];
  }
  return resultMap;
};
